<script setup>
import ScheduleItemsList from './components/ScheduleItemsList.vue'
import Headers from './components/Headers.vue'
import ScheduleItemsGrid from './components/ScheduleItemsGrid.vue'
import SVGDefs from './components/SVGDefs.vue'
// import SleAppStyles from './components/SleAppStyles.vue'
import { useScheduleItemStore } from "@/stores/ScheduleItemStore"
import { storeToRefs } from 'pinia'
import Modal from './components/Modal.vue'

const  store = useScheduleItemStore()

const scheduleData = typeof schedule_data !== undefined ? schedule_data.all_schedule_items.items : []
const workshopData = typeof schedule_data !== undefined ? schedule_data.workshops : []
const locationData = typeof schedule_data !== undefined ? schedule_data.locations : []
const generalSessionData = typeof schedule_data !== undefined ? schedule_data.general_sessions : []
const dateTimeData = typeof schedule_data !== undefined ? schedule_data.all_schedule_items.dateTimes : [] 
const microCopyData = typeof schedule_data !== undefined ? schedule_data.microcopy : []  
store.fillScheduleItems( scheduleData )
store.fillWorkshops( workshopData )
store.fillLocations( locationData )
store.fillGeneralSessions( generalSessionData )
store.fillDateTimes( dateTimeData )
store.fillMicroCopy ( microCopyData )
store.setView( 'compact' )

const { filteredItems } = storeToRefs( store )
const { getLocations } = storeToRefs( store )
const { getDateTimes } = storeToRefs( store )
const { getAllItems } = storeToRefs( store )

const workshops = store.workshops
const sessions = store.generalSessions
const cssVars = ( workshops, sessions ) => {
    let cssVars = '';
    workshops.forEach( (workshop) => {
        cssVars += '.part-of-' + workshop.slug + ','
        cssVars += '.' + workshop.slug + ' { '
        cssVars += '--sles-accent-color: ' + workshop.ws_accent_color + ';'
        cssVars += '--si-bg-color: white;'
        cssVars += ' } '
    })
    sessions.forEach( (session) => {
        cssVars += '.part-of-' + session.slug + ','
        cssVars += '.' + session.slug + ' { '
        cssVars += '--sles-accent-color: ' + session.gs_accent_color + ';'
        cssVars += '--si-bg-color: white;'
        cssVars += ' } '
    })
    return cssVars
}
</script>

<template>
    <div class="sles sles__wrapper">
        <Headers />
        <ScheduleItemsGrid v-if="store.view === 'large' || store.view === 'compact'"
        :items="getAllItems" :dateTimes="getDateTimes" :locations="getLocations" />
        <ScheduleItemsList v-if="store.view === 'list' || store.view === 'favs'" :items="filteredItems" :dateTimes="getDateTimes" :locations="getLocations" :allItems="getAllItems" />
        <SVGDefs />
        <Modal v-if="store.modalState" />

        <component :is="'style'">
            {{ cssVars( workshops, sessions ) }}
        </component>
</div>
</template>
